import {
    CHANGE_STATUS_SEARCH_SCHEDULED_ACTIONS_REQUEST,
    CHANGE_STATUS_CREATE_SCHEDULED_ACTION_REQUEST,
    CHANGE_STATUS_SEARCH_SCHEDULED_ACTIONS_RESULT,
    CHANGE_STATUS_CREATE_SCHEDULED_ACTION_RESULT,
    CHANGE_STATUS_UPDATE_REQUEST,
    CHANGE_STATUS_UPDATE_RESULT,
    CHANGE_STATUS_SET_DEVICES,
    CHANGE_STATUS_CLOSE_MODAL,
    CHANGE_STATUS_OPEN_MODAL,
} from 'Redux/actionTypes';

export const changeStatusSearchScheduledActionsRequest = (data) => ({
    type: CHANGE_STATUS_SEARCH_SCHEDULED_ACTIONS_REQUEST,
    payload: data
})

export const changeStatusSearchScheduledActionsResult = (data) => ({
    type: CHANGE_STATUS_SEARCH_SCHEDULED_ACTIONS_RESULT,
    payload: data
})

export const changeStatusSetDevices = (data) => ({
    type: CHANGE_STATUS_SET_DEVICES,
    payload: data,
})

export const changeStatusOpenModal = (data) => ({
    type: CHANGE_STATUS_OPEN_MODAL,
    payload: data,
})

export const changeStatusCloseModal = () => ({
    type: CHANGE_STATUS_CLOSE_MODAL
})

export const changeStatusUpdateRequest = (data) => ({
    type: CHANGE_STATUS_UPDATE_REQUEST,
    payload: data,
})

export const changeStatusUpdateResult = (result) => ({
    type: CHANGE_STATUS_UPDATE_RESULT,
    payload: result,
})

export const changeStatusCreateScheduledActionRequest = (data) => ({
    type: CHANGE_STATUS_CREATE_SCHEDULED_ACTION_REQUEST,
    payload: data,
})

export const changeStatusCreateScheduledActionResult = (data) => ({
    type: CHANGE_STATUS_CREATE_SCHEDULED_ACTION_RESULT,
    payload: data,
})
